import {
  interval,
  Observable,
} from 'rxjs';
import {
  map,
  take,
} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import moment from 'moment';

export const countdown = (start: number): Observable<number> => interval(1000).pipe(
  map(i => start - i),
  take(start + 1),
);

const URL_DELIMITER_OR_CONTROL = /[/?#\\\p{Cc}]/u;

const DOT_SEGMENTS: readonly string[] = ['.', '..'];

// Rejects a route segment that would change a request URL's structure once interpolated.
export const isUrlSafeUsername = (username: string | null | undefined): username is string => !!username
  && !URL_DELIMITER_OR_CONTROL.test(username)
  && !DOT_SEGMENTS.includes(username);

export const getHttpErrorMessage = (e: HttpErrorResponse): {message: string, statusText: string, status: number} => ({
  message: e.message,
  statusText: e.statusText,
  status: e.status,
});

export const formatDateISO = (dateISOStr: string): string => {
  const date = moment(dateISOStr);
  if (dateISOStr && date.isValid()) {
    return date.format('DD.MM.YYYY HH:mm');
  }
  return dateISOStr;
};
